import React from 'react';

class EditSectionCheckBox extends React.Component {
  constructor( props ) {
    super( props );
    this.checkedIcon = 'edit-section-checkbox-check icon-ikons-#style#-ok';
    this.uncheckedIcon = 'edit-section-checkbox-check icon-ikons-#style#';
    this.state = {
      id: props.id === undefined ? '' : props.id,
      checkSytle: this.getCheckStyle( props.checkStyle ),
      checkClassName: this.getCheckClassName( props.checked, props.checkStyle ),
      checkColor: props.checkColor === undefined ? 'black' : props.checkColor,
      checked: props.checked === undefined ? false : props.checked,
      label: props.label === undefined ? '' : props.label,
      labelColor: props.labelColor === undefined ? 'black' : props.labelColor,
      labelFontSize: props.labelFontSize === undefined ? 'inherit' : props.labelFontSize,
      labelFontBold: props.labelFontBold === undefined ? false : props.labelFontBold,
      readOnly: props.readOnly === undefined ? false : props.readOnly,
      onChanged: props.onChanged,
      hasError: false,
      error: {},
      info: {}
    };

    this.onToggleCheck = this.onToggleCheck.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      id: nextProps.id === undefined ? '' : nextProps.id,
      checkSytle: this.getCheckStyle( nextProps.checkStyle ),
      checkClassName: this.getCheckClassName( nextProps.checked, nextProps.checkStyle ),
      checkColor: nextProps.checkColor === undefined ? 'black' : nextProps.checkColor,
      checked: nextProps.checked === undefined ? false : nextProps.checked,
      labelFontSize: nextProps.labelFontSize === undefined ? 'inherit' : nextProps.labelFontSize,
      labelFontBold: nextProps.labelFontBold === undefined ? false : nextProps.labelFontBold,
      readOnly: nextProps.readOnly === undefined ? false : nextProps.readOnly,
      onChanged: nextProps.onChanged
    } );
  }

  getCheckStyle( style ) {
    let checkStyle = style === undefined ? 'square' : style.toLowerCase();
    if( checkStyle.toLowerCase() === 'square' || checkStyle === 'circle' ) {
      return checkStyle;
    }
    return 'square';
  }

  getCheckClassName( checked, style ) {
    let checkStyle = this.getCheckStyle( style );
    let isChecked = checked === undefined ? false : checked;
    if( isChecked === true ) {
      return this.checkedIcon.replace( '#style#', checkStyle );
    } else {
      return this.uncheckedIcon.replace( '#style#', checkStyle );
    }
  }

  onToggleCheck( e ) {
    if( this.state.readOnly !== true ){
      const checked = !this.state.checked;
      if( this.state.onChanged !== undefined ){
        let e = {
          target: {
            column: this.state.id,
            id: this.state.id,
            value: checked === true ? 1 : 0,
            checked: checked,
          }
        };
        this.state.onChanged( e );
      }
      this.setState( {
        checked: checked
      } );
    }
  }

  render( ) {
    
    if( this.state.hasError === false ) {
      
      const checkStyles = {
        'color': this.state.checkColor
      };

      let labelStyles = {
        'color': this.state.labelColor,
        'fontSize': this.state.labelFontSize
      };


      if( this.state.labelFontBold === true ) {
        labelStyles['fontWeight'] = 'bold';
      }

      let boxStyles = 'edit-section-checkbox';
      if( this.state.readOnly === true ){
        boxStyles = 'edit-section-checkbox-readonly';
      }

      return (
        <span className={boxStyles}>
          <i className={this.state.checkClassName} onClick={this.onToggleCheck} style={checkStyles} />
          <span className="edit-section-checkbox-label" onClick={this.onToggleCheck} style={labelStyles}>
            {this.state.label}
          </span>
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }
}

export default EditSectionCheckBox;



// WEBPACK FOOTER //
// ./src/presentation/EditSectionCheckBox.js